package fyi.moko.hotpl.ui.share

import androidx.compose.runtime.Composable
import kotlinx.browser.window

@Composable
actual fun rememberShareTextLauncher(): (text: String) -> Unit {
    return { text ->
        val navigator = window.navigator
        if (navigator.asDynamic().share != null) {
            navigator.asDynamic().share(
                js("{ text: text }")
            ).catch { err ->
                navigator.clipboard.writeText(text)
                window.alert("Copied to clipboard: $text")
            }
        } else {
            navigator.clipboard.writeText(text)
            window.alert("Copied to clipboard: $text")
        }
    }
}
